import { type MaybeRefOrGetter } from 'vue';
import { useTourSeoInfo } from '@/entities/region/api/useTourSeoInfo.ts';

/**
 * SEO-данные листинга туров по городу без тэга.
 *
 * Дёргает `/api/seo/v2/city_tours/?ids={citySlug}` через generic `getTourSeoById`.
 *
 * @param citySlug slug города
 * @param enabled включена ли загрузка
 * @returns реактивные SEO-данные и флаги загрузки
 */
export const useTourCitySeoInfo = (citySlug: MaybeRefOrGetter<string>, enabled: MaybeRefOrGetter<boolean>) => {
  const { tourSeoData, isSuccess, isFetching } = useTourSeoInfo('city_tours', citySlug, enabled);

  return {
    tourCitySeoData: tourSeoData,
    isSuccess,
    isFetching,
  };
};
